<template>
	<el-form :disabled="onlyRead">
		<el-form-item label="数据类型:" label-width="120px">
			<el-tag>枚举</el-tag>
		</el-form-item>
		<el-form-item v-for="(vue,key) of specs" :label="vue+':'" label-width="120px">
			<!-- <el-tag>{{key}}</el-tag> -->
			<el-input :model-value="key" ></el-input>
		</el-form-item>
	</el-form>
</template>

<script>
	export default {
		name: 'enum',
		mixins: [],
		props: ['specs', 'onlyRead'],
		data() {
			return {}
		}
	}
</script>